<template>
  <a-modal
    :title="title"
    :width="1080"
    :visible="visible"
    @ok="modalok"
    @cancel="modalcancel"
  >
    <div>
      <s-table
        ref="table"
        size="small"
        rowKey="id"
        :loading="cellChopsLoading"
        :row-selection="rowSelection"
        :columns="columnsCellChopsSelected"
        :pageSize="1000"
        :data="loadData"
        :showPagination="false"
      >
        <span slot="rented" slot-scope="text">
          <a-tag :color="text ? 'red' : 'green'">
            {{ text ? '是' : '否' }}
          </a-tag>
        </span>
        <span slot="action" slot-scope="text, record">
          <a-popconfirm
            v-if="record.is_rented"
            title="确定要解除租赁吗？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="handleUnRelated(record)"
          >
            <a>解除租赁</a>
          </a-popconfirm>
        </span>
      </s-table>
    </div>
  </a-modal>
</template>

<script>
import { STable } from '@/components'
import {
  zone_property_cell_chops_list, zone_property_cell_chops_update
} from '@/api/zone_property_cell'
export default {
  name: 'CreatePropertyCellChopsForm',
  components: {
    STable
  },
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      }
    }
    return {
      zonePropertyCellsList: [],
      zonePropertyCellChopsList: [],
      cellChopsLoading: false,
      propertyCellTotal: 0,
      current: 1,
      propertyCellChopsTotal: 0,
      propertyCellChopsCurrent: 1,
      columnsCellChopsSelected: [
        {
          title: '编号',
          width: 100,
          dataIndex: 'number',
          ellipsis: true
        },
        {
          title: '面积',
          width: 100,
          dataIndex: 'area',
          ellipsis: true
        },
        {
          title: '是否已出租',
          width: 100,
          dataIndex: 'is_rented',
          ellipsis: true,
          scopedSlots: { customRender: 'rented' }
        },
        {
          width: 100,
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      selectedRowKeys: [],
      selectedRows: [],
      selectedCellChopsList: [],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return zone_property_cell_chops_list(Object.assign(parameter, { zone_property_cell_id: this.model.zone_property_cell_id }))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      }
    }
  },
  computed: {
    rowSelection () {
      const that = this
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          that.onSelectChange(selectedRowKeys, selectedRows)
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.is_rented
          }
        })
      }
    },
    title () {
      return this.model['zone_property_cell__zone_property__name'] + ' / ' + this.model['zone_property_cell__name'] + ' 展示列表'
    }
  },
  methods: {
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      const selectedCellChopsIds = this.selectedCellChopsList.map(item => item.id)
      this.selectedCellChopsList.push(...this.selectedRows.filter(item => !selectedCellChopsIds.includes(item.id)).map(item => {
        item.zone_property_cell_id = this.model.zone_property_cell_id
        return item
      }))
    },
    modalcancel (e) {
      this.$emit('cancel')
    },
    modalok () {
      this.$emit('ok', this.selectedCellChopsList)
    },
    getZonePropertyCellChopsList (id) {
      this.cellChopsLoading = true
      zone_property_cell_chops_list(Object.assign({}, { zone_property_cell_id: id, page_size: 100, page: 1 }))
        .then(({ data }) => {
          this.zonePropertyCellChopsList = data.entries
          this.propertyCellChopsTotal = data.total
          this.propertyCellChopsCurrent = data.page_number
        }).finally(() => {
        this.cellChopsLoading = false
      })
    },
    handleUnRelated (record) {
      zone_property_cell_chops_update({ is_rented: false }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    }
  }
}
</script>
